import React from 'react'
import useWindowDimensions from '../../functions/useWindowDimension'

const HoverBlock = () => {
  const [mouseOver, setMouseOver] = React.useState(false)
  const { innerWidth } = useWindowDimensions();
  React.useEffect(() => {
    if (innerWidth < 768) {
      setMouseOver(false)
    }
  }, [innerWidth])

  function handleMouseEvent(type) {
    console.log(type)
    if (innerWidth >= 768) {
      switch (type) {
        case 'mouseenter':
          setMouseOver(true)
          break;
        case 'mouseleave':
          setMouseOver(false)
          break;
        default:
          setMouseOver(false)
      }
    }
  }



  return (
    <>
      <li className=" block sm:w-2/4 xl:w-1/4 relative" onMouseEnter={(e) => handleMouseEvent(e.type)} onMouseLeave={(e) => handleMouseEvent(e.type)} >
        <div className="not-hovered" >
          <picture className="block picturePackaging " >
            <img className="w-full mx-auto" alt="Packlane - Mailer Box" src="https://assets.packlane.com/U9fKEiQE5bAcyEUnISimEM6pFBQ0AJb4Co6NvtCS6IA/w:700/ext:png/fn:3d-custom-mailer-box-4d05192912461847fa77e6f162d8e10b/czM6Ly9wYWNrbGFuZS1hc3NldHMvcHJvZHVjdGlvbi9hcHAvaW1hZ2VzLzNkLWN1c3RvbS1tYWlsZXItYm94LTRkMDUxOTI5MTI0NjE4NDdmYTc3ZTZmMTYyZDhlMTBiLnBuZw.png" />
          </picture>
          <h3 className='text-azul pt-4 font-basis text-gray-1 font-bold text-2xl '>
            Mailer Box
          </h3>
          <p className='text-azul font-basis text-gray-1 font-bold tracking-widest uppercase  text-xs '>
            Learn More
          </p>
          <div className='block my-8'>
            <a href="/" className='bg-white text-azul mx-8 block p-4 font-basis text-gray-1 font-bold tracking-widest rounded-full uppercase text-sm' >
              Meet our mailer
            </a>
          </div>
        </div>
        {mouseOver &&
          <div className=" bottom-6 left-6 shadow-packlaneHover top-0 absolute w-full h-full bg-white">
            <a href="/">
              <div className="">
                <picture className='picturePackaging '>
                  <img alt="Packlane - Mailer Box " className="mx-auto w-1/2 px-5 py-10" src="https://assets.packlane.com/images/ico-m-mailer.svg" />
                </picture>
              </div>
            </a>
            <div className="">

              <h3 className="">
                <a href="/" className='transition duration-300 text-azul pt-4 font-basis text-gray-1 font-bold text-2xl hoverText'>Mailer Box </a></h3>
              <a href="/" className="transition duration-300 hoverColorChange text-azul font-basis text-gray-1 font-bold tracking-widest uppercase text-xs">Learn more</a>
              <p className="font-basis font-bold text-gray-1 text-center px-8 py-4 mx-auto text-base md:text-lg">A durable and stylish corrugated cardboard mailer box that's great for shipping. Perfect for subscription boxes, gift boxes, and e-commerce packaging.</p>
              <a href="/" className="transition duration-300 bg-white hover:bg-azul hover:text-white text-azul mx-8 block p-4 font-basis text-gray-1 font-bold tracking-widest rounded-full uppercase text-sm">Meet our mailer</a>
            </div>
          </div>
        }
      </li>
    </>
  )
}



const PackagingStyle = () => {
  return (
    <section className='bg-secundaria flex flex-col w-full items-center w-full pt-28' id="choose-style">
      <div className="w-full m-auto text-center">
        <h2 className="font-tiempo  text-azul font-semibold text-5xl">
          Choose your custom packaging style
        </h2>
      </div>
      <div className="p-4 w-full m-auto text-center block overflow-hidden">
        <ul className="flex flex-col sm:flex-row flex-wrap">
          <HoverBlock />
          <HoverBlock />
          <HoverBlock />
          <HoverBlock />
        </ul>
      </div>
    </section >
  )
}

export default PackagingStyle
